import { render, staticRenderFns } from "./DossierCalculatedFields.vue?vue&type=template&id=6332eebe&"
import script from "./DossierCalculatedFields.vue?vue&type=script&lang=ts&"
export * from "./DossierCalculatedFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6332eebe')) {
      api.createRecord('6332eebe', component.options)
    } else {
      api.reload('6332eebe', component.options)
    }
    module.hot.accept("./DossierCalculatedFields.vue?vue&type=template&id=6332eebe&", function () {
      api.rerender('6332eebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierCalculatedFields.vue"
export default component.exports